import { render } from "./DetailBox.vue?vue&type=template&id=27018aec"
import script from "./DetailBox.vue?vue&type=script&lang=js"
export * from "./DetailBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__